import React from 'react'
import { ConfigProvider } from 'antd'
import { BrowserRouter } from 'react-router-dom'
import { themeConfig } from './theme/config'
import { AppRoutes } from './routes/routes'
import { ApiProvider } from './services/ApiContext'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Analytics } from '@vercel/analytics/react'

export const App: React.FC = () => {
  const captchaKey = import.meta.env.VITE_RECAPTCHA

  return (
    <ConfigProvider theme={themeConfig}>
      <Analytics />
      <GoogleReCaptchaProvider reCaptchaKey={captchaKey}>
        <BrowserRouter>
          <ApiProvider>
            <AppRoutes />
          </ApiProvider>
        </BrowserRouter>
      </GoogleReCaptchaProvider>
    </ConfigProvider>
  )
}
